import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';

import InfoBlock from 'marketing-website/components/modules/infoBlock/index.js';
import bitsBobsData from 'marketing-website/configs/pages/resources/bitsBobsData.js';

import HeadingCopy from 'marketing-website/components/modules/HeadingCopy/HeadingCopy.js';

export default function BitsAndBobs() {
  return (
    <div>
      <HeadingCopy
        title="Bits & Bobs"
        subheading="A collection of online guides and downloadable assets, eBooks and customer stories for you to carry with you."
      />
      <Grid columns={12} justifyContent="left">
        {bitsBobsData.map(item => (
          <GridItem columnSpan={12} columnSpanM={3} columnSpanS={6}>
            <InfoBlock key={item.name} {...item} />
          </GridItem>
        ))}
      </Grid>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/resources/_BitsAndBobs.js